import React, { useCallback, useEffect, useState } from 'react';
import { apiFetch, parseJsonSafe } from '../../utils/api';

const fmtDate = (d) => {
  if (!d) return '-';
  const s = String(d).slice(0, 10);
  const [y, m, day] = s.split('-');
  return (y && m && day) ? `${day}/${m}/${y}` : s;
};

const fmtPrecio = (v) => {
  const n = Number(v);
  if (!Number.isFinite(n)) return '-';
  return n.toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
};

const ClientServicesTab = ({ clientId, onChanged }) => {
  const token = localStorage.getItem('token');
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleUnauthorized = () => {
    localStorage.removeItem('token');
    window.location.href = '/login';
  };

  const fetchServices = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const res = await apiFetch(`/api/services/contracted?clientId=${clientId}`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error((data && data.message) || 'Error cargando servicios contratados');
      setServices(Array.isArray(data) ? data : []);
      if (onChanged) onChanged();
    } catch (err) {
      setServices([]);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [clientId, token, onChanged]);

  useEffect(() => { fetchServices(); }, [fetchServices]);

  return (
    <div>
      <div className="mb-3">
        <h5 className="mb-0">Servicios contratados</h5>
        <div className="text-muted small">Servicios activos derivados de las facturas recurrentes del cliente (solo lectura).</div>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      {loading ? (
        <p className="text-muted">Cargando...</p>
      ) : services.length === 0 ? (
        <div className="text-center text-muted py-4 border rounded bg-light">Sin servicios contratados. Se generan a partir de las facturas recurrentes del cliente.</div>
      ) : (
        <div className="table-responsive">
          <table className="table table-sm align-middle">
            <thead>
              <tr>
                <th>Servicio</th>
                <th>Periodicidad</th>
                <th>Próxima renovación</th>
                <th className="text-end">Precio</th>
              </tr>
            </thead>
            <tbody>
              {services.map((s, i) => (
                <tr key={`${s.factura_id}-${i}`}>
                  <td>{s.concepto || '-'}</td>
                  <td>{s.periodicidad || '-'}</td>
                  <td>{fmtDate(s.proxima_renovacion)}</td>
                  <td className="text-end">{fmtPrecio(s.precio)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ClientServicesTab;
